// Szerver által nem igazolt / hibás lista jelzése (v181, Tamás): akadozó hálózaton a lista a helyi gyorsítótárból üresen érkezhet, vagy a lekérés
// hibázik. Ilyenkor a nézet NEM mondhatja, hogy "még nincs téma / üzenet / szoba - hozd létre az elsőt" (a hozzászólás megvan, csak a válasz nem
// jött meg): külön, figyelmeztető jelzést kap, "Próbáld újra" gombbal.

import { t } from "./i18n.js";
import { el } from "./dom.js";

/** @param {string} uiLang  @param {Function} [onRetry] */
export function renderListaJelzes(uiLang, onRetry) {
  const doboz = el("div", { class: "list-unconfirmed", role: "status" });
  doboz.appendChild(el("p", { class: "list-unconfirmed-text", text: t(uiLang, "common.listUnconfirmed") }));
  if (typeof onRetry === "function") {
    doboz.appendChild(el("button", { type: "button", class: "neutral-btn compact list-unconfirmed-retry", text: t(uiLang, "common.retry"), onclick: () => onRetry() }));
  }
  return doboz;
}
